import React from 'react';
import { Stack, DataList, DataItem } from '@cad-arc';
import { EventDetailsTabAssistingAgencyDto } from '@mark43/cad-api';
import { useApplicationType } from '../../../../../common/hooks/use-application-type';

export function AssistingAgenciesSectionContent({
    assistingAgencies,
}: {
    assistingAgencies: EventDetailsTabAssistingAgencyDto[];
}): React.ReactElement {
    const { isFirstResponder } = useApplicationType();

    return (
        <Stack>
            {assistingAgencies.map((agency) => {
                return (
                    <DataList direction="row" key={agency.agencyProfile}>
                        <DataItem
                            dataKey={`${agency.eventClass} D-Area`}
                            style={{ flexBasis: isFirstResponder ? '50%' : 'auto' }}
                        >
                            {agency.dispatchArea}
                        </DataItem>
                        <DataItem
                            dataKey={`${agency.eventClass} Agency`}
                            style={{ flexBasis: isFirstResponder ? '50%' : 'auto' }}
                        >
                            {agency.agencyProfile}
                        </DataItem>
                    </DataList>
                );
            })}
        </Stack>
    );
}
